import axios from "axios";

import baseDomain, { tagAPI } from "../../Constants/apiRoutes";

export const editTag = (data, tagID) => {
  return axios.put(`${baseDomain}${tagAPI}/${tagID}`, data);
};
